import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    unitName?: string;
}

export default function DisplacedReasonsDropdown({ value, setValue, zIndex }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getDisplaceReasons() {
        try {
            const displacedReasons = await dispatchService.getDisplaceReasons();
            setItems(displacedReasons.map((item) => {
                return { label: item.name, value: item.id };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getDisplaceReasons();
    }, []);

    return (
        <FilterDropdown
            label={translate('displaced')}
            items={items}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
